import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CaretRight } from "@phosphor-icons/react";

// Generic drill-through list rendered as a modal. Rows can open the drawer.
export const ListDialog = ({ open, onOpenChange, title, description, rows, columns, onRowClick, emptyText }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl" data-testid="mc-list-dialog">
      <DialogHeader>
        <DialogTitle className="font-serif text-xl">{title}</DialogTitle>
        {description ? <DialogDescription>{description}</DialogDescription>
          : <DialogDescription className="sr-only">Drill-through list</DialogDescription>}
      </DialogHeader>
      {(!rows || rows.length === 0) ? (
        <p className="text-sm text-muted-foreground py-8 text-center">{emptyText || "Nothing to show."}</p>
      ) : (
        <ScrollArea className="max-h-[60vh] -mx-2 px-2">
          <ul className="divide-y divide-border">
            {rows.map((r, i) => (
              <li
                key={r.id || i}
                data-testid={`mc-list-row-${i}`}
                onClick={onRowClick ? () => onRowClick(r) : undefined}
                className={`py-3 flex items-center gap-3 ${onRowClick ? "cursor-pointer hover:bg-[hsl(36_30%_96%)] -mx-2 px-2 rounded-md" : ""}`}
              >
                <div className="min-w-0 flex-1 grid gap-0.5">
                  {columns.map((c, ci) => (
                    <div key={ci} className={c.primary ? "text-sm font-semibold truncate" : "text-xs text-muted-foreground truncate"}>
                      {c.render(r)}
                    </div>
                  ))}
                </div>
                {onRowClick && <CaretRight size={14} className="text-muted-foreground shrink-0" />}
              </li>
            ))}
          </ul>
        </ScrollArea>
      )}
    </DialogContent>
  </Dialog>
);
